import { Component, OnInit } from '@angular/core';
import {NgbDate, NgbCalendar, NgbDateParserFormatter, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import * as _ from 'lodash';
import { saveAs as importedSaveAs } from "file-saver";
import { ServiceService } from 'src/app/services/service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Color, Label } from 'ng2-charts';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Chart } from 'chart.js';
import * as ChartAnnotation from 'chartjs-plugin-annotation';
import { NgbCustomDateParserService } from 'src/app/formatters/ngb-custom-date-parser.service';
import { StationInventoryService } from './station-inventory.service';
import { SortingCurrentStatus, SortingModel } from '../dashboard-mngnt/sortingModel';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-station-inventory',
  templateUrl: './station-inventory.component.html',
  styleUrls: ['./station-inventory.component.scss', 
  '../../../../../scrollbar.scss', 
  '../inventory-loads/inventory-loads.component.scss',
  './switch.scss']
})
export class StationInventoryComponent implements OnInit {

  showLevels = true;
  noOfRecord: number = 50;
  data: any;
  page = 0;
  gradientFill = false;
  showOverlay = false;
  user: any;
  previouslySelectedItem;
  previouslySelectedTank;
  smoothnessIndex = 1;
  dealerSearchParam = "";


  selectedSupplier = null;
  selectedTerminal = null;
  fillWithGradient = false;
  
  /**Filter params. */
  public selectedDealer = null;
  public orderNoFilter = null;
  public carrierFilter = null;
  public terminalFilter = null;
  public supplierFilter = null;
  public dealerFilter = null;
  public bolStatusFilter = null;
  public notesFilter = null;
  public filterQuery = null;
  public bolstatusMap = new Map();
  
  public showInvoices: boolean = false;
  public hideOrShow: boolean = false;
  public readingsHistory = {};


  fromDate: NgbDate;
  toDate: NgbDate;
  hoveredDate: NgbDate;
  daysDifference = 5;
  todayIsAt = 0;

  
  fromDateDup: any;
  toDateDup: any;

  modalRef: any;
  selectedItem: any;
  treatTanksSeparately = false;

  from_date: any;
  to_date: any;
  public tblReadings: any = [];

  public lineChartData: any[] = [];
  public lineChartLabels: Label[] = [];
  public lineChartTooltipLables: Label[] = [];
  public lineChartOptions: any;
  public lineChartColors: Color[] = [
    {
      borderColor: '#0000EE',
      backgroundColor: '#627d9433',
    },
    {
      borderColor: '#0000EE',
      backgroundColor: '#c353671c',
    },
    {
      borderColor: 'gray',
      backgroundColor: '#24ca851c',
    },
    {
      borderColor: 'gray',
      backgroundColor: '#6165639e',
    },
  ];
  public lineChartLegend = true;
  public lineChartType = 'line';
  public lineChartPlugins = [];

  barChartOptions: ChartOptions = {
    responsive: true,
  };

  barChartLabels: Label[] = [];
  barChartType: ChartType = 'bar';
  barChartLegend = false;
  barChartPlugins = [];

  barChartData: ChartDataSets[] = [
  ];
  sortingModels: SortingModel[] = [];
  sortingCurrentStatus: SortingCurrentStatus = new SortingCurrentStatus();

  public colorCodes = {
    "regular" : "#f5dc61",
    "super" : "red",
    "plus" : "blue",
    "uls" : "yellow",
    "dyed" : "#61e623",
    "misc" : "black"
}

  constructor(private calendar: NgbCalendar, public formatter: NgbDateParserFormatter,
    private route: ActivatedRoute,
    private router: Router,
    private ngModal: NgbModal,
    private datePipe: DatePipe, 
    private service: ServiceService,
    private utilService: UtilService,
    public ngbCustomDateParserService: NgbCustomDateParserService,
    public stationInventoryService: StationInventoryService) {
      this.user = JSON.parse(localStorage.getItem("user"));
      // this.showInvoices = this.user.user.showInvoices;
      // var ctx = document.getElementById("canvas").getContext("2d");
      this.getTenantActivities(false);
      this.fromDate = calendar.getPrev(calendar.getToday(), 'd', 5);
      this.toDate = calendar.getNext(calendar.getToday(), 'd', 0);
  }

  insertSortingObject(fieldName) {
    var sortingModel: SortingModel = new SortingModel();
    sortingModel.fieldName = fieldName;

    this.checkAndChangeSortingStatus(fieldName);
    this.getTenantActivities()

    var matchFound = false;
    var index: number = 0;
    for (let individualSortingModel of this.sortingModels) {
      if (individualSortingModel.equals(sortingModel)) {
        matchFound = true;
        break;
      }
      index++;
    }

    if (!matchFound) {
      this.sortingModels.push(sortingModel);
      this.sortingModels[this.sortingModels.length - 1].changeStatus();
    } else {
      var changeStatus: boolean = this.sortingModels[index].changeStatus();
      if (!changeStatus) {
        this.sortingModels.splice(index, 1);
      }
    }
    // this.getBillOfLaddingsWithSorting()

  }

  private checkAndChangeSortingStatus(fieldName: any) {
    let currentStatusValue = "", currentStatusFieldName = "";
    if (fieldName == "tac") {
      var tacStatus = this.sortingCurrentStatus.tacStatus;
      this.sortingCurrentStatus.tacStatus = tacStatus == 'asc' ? 'desc' : tacStatus == 'desc' ? 'NA' : tacStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.tacStatus;
      currentStatusFieldName = "tacStatus";
    }
    if (fieldName == "dealer") {
      var dealerStatus = this.sortingCurrentStatus.dealerStatus;
      this.sortingCurrentStatus.dealerStatus = dealerStatus == 'asc' ? 'desc' : dealerStatus == 'desc' ? 'NA' : dealerStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.dealerStatus;
      currentStatusFieldName = "dealerStatus";
    }
    if (fieldName == "address") {
      var addressStatus = this.sortingCurrentStatus.addressStatus;
      this.sortingCurrentStatus.addressStatus = addressStatus == 'asc' ? 'desc' : addressStatus == 'desc' ? 'NA' : addressStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.addressStatus;
      currentStatusFieldName = "addressStatus";
    }
    if (fieldName == "city") {
      var cityStatus = this.sortingCurrentStatus.cityStatus;
      this.sortingCurrentStatus.cityStatus = cityStatus == 'asc' ? 'desc' : cityStatus == 'desc' ? 'NA' : cityStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.cityStatus;
      currentStatusFieldName = "cityStatus";
    }
    if (fieldName == "state") {
      var stateStatus = this.sortingCurrentStatus.stateStatus;
      this.sortingCurrentStatus.stateStatus = stateStatus == 'asc' ? 'desc' : stateStatus == 'desc' ? 'NA' : stateStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.stateStatus;
      currentStatusFieldName = "stateStatus";
    }
    if (fieldName == "supplier") {
      var supplierStatus = this.sortingCurrentStatus.supplierStatus;
      this.sortingCurrentStatus.supplierStatus = supplierStatus == 'asc' ? 'desc' : supplierStatus == 'desc' ? 'NA' : supplierStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.supplierStatus;
      currentStatusFieldName = "supplierStatus";
    }
    if (fieldName == "status") {
      var statusStatus = this.sortingCurrentStatus.statusStatus;
      this.sortingCurrentStatus.statusStatus = statusStatus == 'asc' ? 'desc' : statusStatus == 'desc' ? 'NA' : statusStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.statusStatus;
      currentStatusFieldName = "statusStatus";
    }
    if (fieldName == "scheduleDate") {
      var dateStatus = this.sortingCurrentStatus.dateStatus;
      this.sortingCurrentStatus.dateStatus = dateStatus == 'asc' ? 'desc' : dateStatus == 'desc' ? 'NA' : dateStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.dateStatus;
      currentStatusFieldName = "dateStatus";
    }
    if (fieldName == "eta") {
      var etaStatus = this.sortingCurrentStatus.etaStatus;
      this.sortingCurrentStatus.etaStatus = etaStatus == 'asc' ? 'desc' : etaStatus == 'desc' ? 'NA' : etaStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.etaStatus;
      currentStatusFieldName = "etaStatus";
    }
    if (fieldName == "billoflading") {
      var bolStatus = this.sortingCurrentStatus.bolStatus;
      this.sortingCurrentStatus.bolStatus = bolStatus == 'asc' ? 'desc' : bolStatus == 'desc' ? 'NA' : bolStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.bolStatus;
      currentStatusFieldName = "bolStatus";
    }
    if (fieldName == "total") {
      var totalStatus = this.sortingCurrentStatus.totalStatus;
      this.sortingCurrentStatus.totalStatus = totalStatus == 'asc' ? 'desc' : totalStatus == 'desc' ? 'NA' : totalStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.totalStatus;
      currentStatusFieldName = "totalStatus";
    }


    this.resetOthers(currentStatusFieldName, currentStatusValue);
  }
  private resetOthers(filterFlagName, filterValue) {
    this.sortingCurrentStatus = new SortingCurrentStatus();
    this.sortingCurrentStatus[filterFlagName] = filterValue;
    return this.sortingCurrentStatus;
  }


  assignBarChartData(){
    this.barChartLabels.push("SUN","MON","TUE","WED","THU","FRI", "SAT", 
    "SUN","MON","TUE","WED","THU","FRI", "SAT", 
    "SUN","MON","TUE","WED","THU","FRI", "SAT",
    "SUN","MON","TUE","WED","THU","FRI", "SAT");
    var barChartElement = { data: 
      [5,3,2,6,2,9, 5, 
      5,3,2,6,2,9, 5, 
      5,3,2,6,2,9, 5,
      5,3,2,6,2,9, 5], label: 'Tenants' };
    var barChartTotalElement = { data: 
      [5,9,3,8,7,5,8, 
      5,9,6,8,7,5,8, 
      5,9,6,8,7,5,8,
      5,9,6,8,7,5,8], label: 'Totals' };
    
    this.barChartData = [];
    this.barChartData.push(barChartElement);
    this.barChartData.push(barChartTotalElement);
  }

  ngOnInit(){
    let namedChartAnnotation = ChartAnnotation;
    namedChartAnnotation["id"]="annotation";
    Chart.pluginService.register( namedChartAnnotation);
    this.assignBarChartData();
    this.reFormLineChartSettings(120);
  }

  public getTenantActivities(csvExport?: boolean): void {
    this.generateDefaultDateFilters();
    $(".overlay-loading").show();
    let sortBy = "locationID";
    let orderBy = "asc";
    for(let key in this.sortingCurrentStatus){
      if(this.sortingCurrentStatus[key] !== "NA"){
        sortBy = key.replace('Status', '');
        orderBy = this.sortingCurrentStatus[key];
      }
    }
    console.log("Current sort", this.sortingCurrentStatus)
    let url = 'get-station-phone-book?size='+this.noOfRecord+'&page=0&sort-by='+sortBy+'&order-by='+orderBy+(this.dealerSearchParam?'&search-param='+this.dealerSearchParam: '');
    this.service.getTenantActivities(
      url, this.from_date, this.to_date,this.filterQuery, this.orderNoFilter, this.carrierFilter,
      this.terminalFilter,
      this.supplierFilter,
      this.dealerFilter,
      this.bolStatusFilter,
      this.notesFilter,
      csvExport
      ).subscribe(data => {
        if(csvExport) {
          var mediaType = "text/csv";
          var blob = new Blob([data], { type: mediaType });
          var filename = 'stationInventory-' + this.from_date.substr(0, 10) + '-' + this.to_date.substr(0, 10) + '.csv';
          importedSaveAs(blob, filename);
        } else {
          this.data = data;
          this.selectedItem = data[0];
          
          this.loadDealerData(this.selectedItem.dealer+":"+this.selectedItem.address+":"+this.selectedItem.city)
          this.openModalForDetails(null, this.selectedItem);
        }
        $(".overlay-loading").hide();
     
    });

  }

  public openModalForDetails(content: any, item: any): void {
    $(".overlay-loading").show();
    this.previouslySelectedItem = item;
    this.service.findDealerAndStationDetails(item.locationID+':'+item.tenant).subscribe(res => {
      this.selectedItem = res;
      this.selectedItem.billtype = item.billtype;
      this.selectedItem.tac = item.tac;

      
      let uniqueTanks = [];
      this.selectedItem.tblTanks.forEach(tblTank => {
        const selectedIndex = uniqueTanks?.findIndex((tank) => tank?.tankName === tblTank?.tankName)
        tblTank.counterTemp = tblTank.counter;
        if (selectedIndex == -1) {
          uniqueTanks.push(tblTank);
        } else{
          uniqueTanks[selectedIndex].counterTemp += ":"+tblTank.counterTemp;
          console.log(selectedIndex);
        }
      })

      this.selectedItem.tblTanksTemp = uniqueTanks;
      for(let i = 0; i<this.selectedItem.tblTanksTemp.length; i++){
        let curentDate:any = new Date();
        let formatted_current_date:any = this.datePipe.transform(this.fromDateDup, 'yyyy-MM-dd HH:mm:ss');
        
        this.fromDateDup = new Date();
        this.fromDateDup.setDate(this.fromDateDup.getDate() + 1);
        let formatted_tstamp_date:any = this.datePipe.transform(this.fromDateDup, 'yyyy-MM-dd HH:mm:ss');
        let tank = this.selectedItem.tblTanksTemp[i];
        let tblReading:any = {
          'tankid':this.selectedItem.tblTanksTemp[i].counter,
          'gallons':null,
          'date':  formatted_current_date,
          'invTime': formatted_current_date,
          'productName':this.selectedItem.tblTanksTemp[i].tankName,
          'tenant': JSON.parse(localStorage.getItem("user-tenant")).tenantId,
          'updatesource': 'WEB',
          'TStamp':formatted_tstamp_date
        }

        
        let fromDate = new Date();
        this.lineChartData = [];
          this.lineChartLabels = [];
        fromDate.setDate(fromDate.getDate() - this.daysDifference);
        let formatted_tstamp_date_new:any = this.datePipe.transform(fromDate, 'yyyy-MM-dd HH:mm:ss');
        

        let toDate = new Date();
        let formatted_tstamp_to_date_new:any = this.datePipe.transform(toDate, 'yyyy-MM-dd HH:mm:ss');
        

        let todayFound = false;
        this.readingsHistory = [];
        this.service.findInventoryHistory(tank.counterTemp, tank.tenant, formatted_tstamp_date_new, formatted_tstamp_to_date_new, this.treatTanksSeparately).subscribe(inventory => {
          console.log("Inventory history", inventory);
          this.todayIsAt = inventory.todayAfter;
          if(i == 0){
            this.reFormLineChartSettings(this.todayIsAt)
            this.service.findInventoryHistory(tank.counterTemp, tank.tenant, formatted_tstamp_date_new, formatted_tstamp_to_date_new, this.treatTanksSeparately).subscribe(inventory => {
              this.pushTankData(inventory, this.selectedItem.tblTanksTemp[i], todayFound)
            })
          }else{
            this.pushTankData(inventory, this.selectedItem.tblTanksTemp[i], todayFound)
          }
        });
        this.tblReadings.push(tblReading);
      }
      $(".overlay-loading").hide();
    });
    
    // this.modalRef = this.ngModal.open(content,{
    //   size: "lg"
    // });
  }
  
  public openModalForTanks(item: any): void {
    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - this.daysDifference);
    let formatted_tstamp_date_new:any = this.datePipe.transform(fromDate, 'yyyy-MM-dd HH:mm:ss');
    

    let toDate = new Date();
    let formatted_tstamp_to_date_new:any = this.datePipe.transform(toDate, 'yyyy-MM-dd HH:mm:ss');
    

    this.previouslySelectedTank = item;
    this.stationInventoryService.openModalForTanks(item, this.readingsHistory, 
      formatted_tstamp_date_new, formatted_tstamp_to_date_new);
  }

  private reFormLineChartSettings(multiplicationFactor: number) {
    this.lineChartOptions = {
      responsive: true,
      title: {
        display: false,
        text: "Tank Data"
      },
      tooltips: {
        mode: "index",
        intersect: false,
        callbacks: {
          title: (tooltipItem, data) => {
              return this.lineChartTooltipLables[tooltipItem[0].index];
          }
        }
      },
      legend: {
        display: true,
        position: "top",
        labels: {
          fontColor: "black"
        }
      },
      annotation: {
        annotations: [
          {
            type: "line",
            mode: "vertical",
            value: multiplicationFactor,
            scaleID: "x-axis-0",
            borderColor: "red",
            label: {
              content: "Today",
              enabled: true,
              position: "top"
            }
          }
        ]
      }
    };
  }

  pushTankData(inventory, tank, todayFound){
    let ctr = 0;
    for (var prop in inventory?.readings) {
      if(!this.readingsHistory[prop]){
        this.readingsHistory[prop] = [];
      }

      this.readingsHistory[prop]?.push(inventory?.readings[prop]);
      console.log("Tank History", this.readingsHistory)
      
      this.lineChartLabels = [];
      let data = [];
      this.lineChartTooltipLables = [];
      inventory?.readings[prop]?.forEach(inv => {
        
        if(ctr%this.smoothnessIndex == 0 && inv?.gallons >= 0){
          data.push(inv?.gallons);
          // console.log("Inv "+inv?.gallons+" Date "+inv?.date);
          let dateInclusive = this.datePipe.transform(inv?.date, 'yyyy-MM-dd HH:mm:ss');
          this.lineChartTooltipLables.push(this.datePipe.transform(inv?.date, 'MM/dd/yy HH:mm EEE'));
          // console.log("Original Date", inv?.date);
            // console.log("Orig"+inv?.date+" Trans", this.datePipe.transform(inv?.date, 'MM/dd/yy HH:mm EEE'));
          if(dateInclusive.includes(' 00:') || dateInclusive.includes(" 21:")
          || dateInclusive.includes(" 22:") || dateInclusive.includes(" 23:")
          || dateInclusive.includes(" 20:")){
            
            this.lineChartLabels.push(this.datePipe.transform(inv?.date, 'MM-dd EEE'));
          }else{
              this.lineChartLabels.push(this.datePipe.transform(inv?.date, 'HH:00'));
          }
          if(!inv.idHub && !todayFound){
            todayFound = true;
          }
        }
        ctr++;
      });

      // let tankData = { data: data, label: tank.tankName,  pointRadius: 1, pointBorderColor: this.findColor(tank.tankName), pointBorderWidth: 2, 
      //   pointBackgroundColor:this.findColor(tank.tankName), fill: false, borderColor: this.findColor(tank.tankName), backgroundColor: this.findColor(tank.tankName), borderWidth: 1};
      //   this.lineChartData.push(tankData);

        let tankData = { data: data, label: tank.tankName,  pointRadius: 1, pointBorderColor: this.colorCodes[this.utilService.selectClass(tank?.displayCode? tank?.displayCode : tank?.tankName)], pointBorderWidth: 2, 
          pointBackgroundColor:this.colorCodes[this.utilService.selectClass(tank?.displayCode? tank?.displayCode : tank?.tankName)], fill: false, borderColor: this.colorCodes[this.utilService.selectClass(tank?.displayCode? tank?.displayCode : tank?.tankName)], backgroundColor: this.colorCodes[this.utilService.selectClass(tank?.displayCode? tank?.displayCode : tank?.tankName)], borderWidth: 1};
          this.lineChartData.push(tankData);
    }
    
    
  }

  findColor(product) {
    product = product.toLowerCase();
    let colorCode;
    if (product.includes('reg')) {
      if (this.fillWithGradient) {
        colorCode = {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 1,
            y2: 1
          },
          stops: [
            [0, '#f6f9fb'],
            [1, '#ebecf3']
          ]
        };
      } else {
        // colorCode = '#cec9c9';
        colorCode = 'black';
      }
    } else if (product.includes('premium') || product.includes('super')) {
      if (this.fillWithGradient) {
        colorCode = {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 1,
            y2: 1
          },
          stops: [
            [0, '#f47a0f'],
            [1, '#ee220d']
          ]
        };
      } else {
        colorCode = '#bd0a0a';
      }
    } else if (product.includes('mid')) {
      colorCode = '#92d4f3'
    } else if (product.includes('uls')) {
      if (this.fillWithGradient) {
        colorCode = {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 1,
            y2: 1
          },
          stops: [
            [0, '#f4f812'],
            [1, '#d5ee07']
          ]
        };
      } else {
        colorCode = '#d5d509';
      }
    } else if (product.includes('plus')) {
      if (this.fillWithGradient) {
        colorCode = {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 1,
            y2: 1
          },
          stops: [
            [0, '#93c7e6'],
            [1, '#a0a4f5']
          ]
        };
      } else {
        return 'yellow';
      }
    } else if (product.includes('ullage')) {
      if (this.fillWithGradient) {
        colorCode = {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 1,
            y2: 1
          },
          stops: [
            [0, 'rgb(255, 255, 255, 0.5)'],
            [1, 'rgb(200, 200, 200, 0.5)']
          ]
        };
      } else {
        colorCode = '#8db7f64d';
      }
    } else if (product.includes('capacity')) {
      if (this.fillWithGradient) {
        colorCode = {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 1,
            y2: 1
          },
          stops: [
            [0, 'rgb(255, 255, 255, 0.5)'],
            [1, 'rgb(200, 200, 200, 0.5)']
          ]
        };
      } else {
        colorCode = '#8db7f65e';
      }
    } else {
      colorCode = 'black';
    }

    return colorCode;
  }

  loadDealerData(dealer){
    this.dealerFilter = dealer;
    console.log("dealerFIlter"+this.dealerFilter);
  }

  public openModalForGraph(content: any, item: any): void {

   
    this.modalRef = this.ngModal.open(content,{
      size: "lg"
    });
  }


  private generateDefaultDateFilters(): void {
    this.fromDateDup = new Date();
    this.toDateDup = new Date();
    this.fromDateDup.setDate(this.fromDateDup.getDate() - 30);
    this.from_date = this.datePipe.transform(this.fromDateDup, 'yyyy-MM-dd 00:00:00');
    this.to_date = this.datePipe.transform(this.toDateDup, 'yyyy-MM-dd 00:00:00');
  }

  public resetFilter(): void {
    this.filterQuery = '';
    this.dealerSearchParam = null;
    this.getTenantActivities(false);
  }

  
  validateInput(currentValue: NgbDate, input: string): NgbDate {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  formatDateForDisplay(date) {
    if(date){
      return this.ngbCustomDateParserService.format(date);
    }
  }

  closeDatePicker = false;
  onDateSelection(date: NgbDate) {
    this.closeDatePicker = false;
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
      this.closeDatePicker = true;
      this.showOverlay = false;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }


  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
  }

  isOldReading(readingDate){
    return this.isDateGreater(new Date(), readingDate, 1);
  }
  /**
 * Check if d2 is greater than d1
 * @param {String|Object} d1 Datestring or Date object
 * @param {String|Object} d2 Datestring or Date object
 * @param {Number} days Optional number of days to add to d1
 */
 isDateGreater(d1, d2, days) {
  d1 = new Date(d1);
  d2 = new Date(d2);
  let isInRange = +d1 >= d2.setDate(d2.getDate() + (days||0));
  return  isInRange;
}
}